{
	"common": {
		"cancel": "Cancel",
		"close": "Close",
		"choose": "Choose",
		"clearFilters": "Clear filters",
		"loading": "Loading…",
		"noMatches": "No matches",
		"optional": "Optional",
		"retry": "Try again",
		"search": "Search"
	},
	"page": {
		"title": "Helpdesk",
		"count_one": "{{n}} ticket",
		"count_other": "{{n}} tickets",
		"intro": "Room problems reported by contingents, hotels and the desk. Open and in progress first.",
		"introReporter": "The room problems your contingent reported, and what the host team did about them."
	},
	"status": {
		"label": {
			"OPEN": "Open",
			"IN_PROGRESS": "In progress",
			"RESOLVED": "Resolved"
		},
		"hint": {
			"OPEN": "Reported, nobody is on it yet",
			"IN_PROGRESS": "The front desk is working on it",
			"RESOLVED": "Fixed and closed"
		}
	},
	"priority": {
		"label": {
			"LOW": "Low",
			"MEDIUM": "Medium",
			"HIGH": "High",
			"URGENT": "Urgent"
		}
	},
	"source": {
		"DESK": "Reported at the desk",
		"NOC": "Reported by the contingent",
		"HOTEL": "Reported by the hotel",
		"PARTICIPANT": "Reported by the participant"
	},
	"guide": {
		"title": "Helpdesk statuses",
		"roomProblems": "Room problems"
	},
	"list": {
		"search": "Ticket, Room, Contingent or Problem",
		"searchReporter": "Ticket, Room or Problem",
		"sortNewest": "Newest first",
		"sortPriority": "Priority",
		"statusChips": "Ticket status",
		"building": "Building",
		"contingent": "Contingent",
		"showing_one": "Showing {{from}} to {{to}} of {{total}} ticket",
		"showing_other": "Showing {{from}} to {{to}} of {{total}} tickets",
		"showingNoTotal": "Showing {{from}} to {{to}}",
		"showingEmpty": "No tickets",
		"loadFailed": "Couldn't load the tickets",
		"emptyOpenTitle": "No open tickets",
		"emptyTitle": "No tickets",
		"emptyFilteredTitle": "No tickets match",
		"emptyDescription": "Contingents report room problems from their rooming page, and hotels from their desk. They show here.",
		"emptyReporter": "Report a room problem from your rooming list and the host team picks it up."
	},
	"ticket": {
		"loadingTitle": "Ticket",
		"where": "Where",
		"contingent": "Contingent",
		"contact": "Contact",
		"priority": "Priority",
		"status": "Status",
		"assignee": "Handled by",
		"details": "Details",
		"timeline": "Updates",
		"noNotes": "No updates yet.",
		"statusNote": "Status → {{status}}",
		"addNote": "Add a note",
		"notePlaceholder": "What was done, or what the team said",
		"update": "Update ticket",
		"updated": "Updated {{ticket}}",
		"updateFailed": "Couldn't update the ticket",
		"close": "Close",
		"buildingRoom": "{{building}}, room {{room}}",
		"orgCodeName": "{{code}} · {{name}}"
	},
	"create": {
		"open": "New ticket",
		"title": "New ticket",
		"description": "A room problem reported by phone or at the desk",
		"problem": "Problem",
		"problemPlaceholder": "Air conditioning not working",
		"contingent": "Contingent",
		"building": "Building",
		"roomNumber": "Room number",
		"roomNumberPlaceholder": "A-412",
		"contactName": "Contact person",
		"contactPhone": "Their phone",
		"notes": "Notes",
		"notesPlaceholder": "What was reported, and what was done so far",
		"submit": "Create ticket",
		"created": "Created {{ticket}}",
		"failed": "Couldn't create the ticket"
	},
	"report": {
		"open": "Report a room problem",
		"title": "Report a room problem",
		"description": "The host's accommodation team picks it up",
		"whatIsWrong": "What is wrong?",
		"room": "Room",
		"roomOption": "{{building}} · {{room}}",
		"noRooms": "None of your people has a room yet.",
		"howUrgent": "How urgent?",
		"details": "Details",
		"submit": "Send to the host",
		"sent": "Sent to the host · {{ticket}}",
		"failed": "Couldn't send the report"
	},
	"validation": {
		"roomRequired": "Choose the room",
		"roomNotFound": "No room {{room}} in this building",
		"noteMax": "At most {{max}} characters"
	},
	"refusal": {
		"not_found": "Not found",
		"card_not_ready": "AC card not ready yet",
		"stay_not_started": "Their stay has not started",
		"stay_ended": "Their stay has ended",
		"already_in": "Already checked in",
		"not_in": "Not checked in",
		"already_out": "Already checked out",
		"checked_out_first": "Checked out. Undo that first"
	},
	"noc": {
		"title": "Rooming list",
		"count_one": "{{n}} person",
		"count_other": "{{n}} people",
		"intro": "Your people with an approved card and the room the host gave them. The host assigns rooms; tell them if something is wrong.",
		"org": "Contingent",
		"headquarters": "Headquarters",
		"download": "Download",
		"downloadFailed": "Couldn't download the rooming list",
		"csvFilename": "rooming-list-{{org}}.csv",
		"loadFailed": "Couldn't load your rooming",
		"noPeopleTitle": "Nobody to room yet",
		"noPeopleDescription": "People appear here once their AC card is approved.",
		"strip": {
			"label": "Your rooming today",
			"people": "People",
			"haveBed": "Have a bed",
			"checkedIn": "Checked in",
			"withoutBed": "Without a bed",
			"hostAssigning": "The host is assigning",
			"none": "None",
			"roomProblems": "Room problems",
			"open": "Open"
		},
		"list": {
			"search": "Name, AC Number or Sport",
			"stateChips": "Rooming status",
			"sort": {
				"name": "Name",
				"team": "Team",
				"room": "Room"
			},
			"name": "Name",
			"team": "Team",
			"room": "Room",
			"stay": "Stay",
			"status": "Status",
			"notAssigned": "Not assigned yet",
			"range_one": "Showing {{from}} to {{to}} of {{total}} person",
			"range_other": "Showing {{from}} to {{to}} of {{total}} people",
			"rangeEmpty": "Nobody",
			"emptyTitle": "Nobody to room yet",
			"emptyDescription": "People appear here once their AC card is approved.",
			"emptyFilteredTitle": "Nobody matches",
			"emptyFilteredDescription": "Try another status or search."
		},
		"problems": {
			"title": "Room problems",
			"all": "All room problems",
			"hostNote": "Host: {{note}}",
			"emptyTitle": "No room problems reported",
			"emptyDescription": "If something breaks in a room, report it and the host sends someone."
		}
	},
	"hotel": {
		"title": "Front desk",
		"zoneNote": "Times are {{zone}}",
		"updated": "Updated {{time}}",
		"refresh": "Refresh now",
		"buildingChips": "Building",
		"loadFailed": "Couldn't load the desk",
		"strip": {
			"label": "Today at the desk",
			"arriving": "Arriving",
			"toCheckIn": "{{n}} to check in",
			"overdue": "Overdue",
			"overdueNote": "Due earlier, not in yet",
			"inHouse": "In house",
			"departing": "Departing",
			"toCheckOut": "{{n}} to check out"
		},
		"tab": {
			"label": "Desk lists",
			"arriving": "Arriving",
			"inHouse": "In house",
			"departing": "Departing"
		},
		"groupedArriving": "Grouped by arrival, so a whole bus is checked in at once.",
		"groupedDeparting": "Grouped by departure. Collect key cards before the transfer leaves.",
		"truncated": "Showing the first groups only. Pick one building to see the rest.",
		"emptyArrivingTitle": "Nobody arrives on this day",
		"emptyArriving": "Guests whose first night is this day show here, grouped by flight.",
		"emptyDepartingTitle": "Nobody leaves on this day",
		"emptyDeparting": "Guests whose stay ends this day show here, with the time to check out by.",
		"emptyInHouseTitle": "Nobody is checked in",
		"emptyInHouse": "Checked-in guests show here until they check out.",
		"emptyInHouseFiltered": "Nobody matches",
		"inHouseSearch": "Name, AC Number or Room",
		"inHouseRange_one": "Showing {{from}} to {{to}} of {{total}} guest",
		"inHouseRange_other": "Showing {{from}} to {{to}} of {{total}} guests",
		"room": "Room {{room}}",
		"photoOf": "Photo of {{name}}",
		"checkOutOne": "Check out",
		"checkedOutOne": "{{name}} checked out",
		"checkedIn_one": "{{n}} person checked in",
		"checkedIn_other": "{{n}} people checked in",
		"checkedOut_one": "{{n}} person checked out",
		"checkedOut_other": "{{n}} people checked out",
		"checkInFailed": "Couldn't check in",
		"checkOutFailed": "Couldn't check out",
		"group": {
			"noTravel": "No travel on file",
			"ownWay": "Own way",
			"lands": "Lands",
			"departs": "Departs",
			"atHotel": "At the hotel",
			"checkOutBy": "Check out by",
			"inOf": "{{done}} of {{total}} checked in",
			"outOf": "{{done}} of {{total}} checked out",
			"people": "People",
			"checkIn": "Check in {{n}}",
			"checkOut": "Check out {{n}}",
			"done": "Done",
			"noWindow": "No time yet",
			"orgsMore": "{{orgs}} +{{n}}"
		},
		"sheet": {
			"description_one": "{{n}} guest",
			"description_other": "{{n}} guests",
			"keysIn": "Hand out key cards. Check each face against the photo.",
			"keysOut": "Collect key cards and check the rooms.",
			"pick": "Select {{name}}",
			"loadFailed": "Couldn't load the guests",
			"skipped_one": "{{n}} person skipped",
			"skipped_other": "{{n}} people skipped",
			"skipLine": "{{name}}: {{reason}}"
		},
		"undo": {
			"in": "Undo check-in",
			"out": "Undo check-out",
			"confirmIn": "Undo this check-in?",
			"confirmOut": "Undo this check-out?",
			"yes": "Undo",
			"no": "Keep",
			"inDone": "Check-in undone for {{name}}",
			"outDone": "Check-out undone for {{name}}",
			"failed": "Couldn't undo"
		}
	},
	"groupHotels": {
		"permissionsMissing": "Its logins can see their guests but cannot check them in or out, or work room problems. That needs {{permissions}} in this group's permissions.",
		"grant": "Allow the front desk",
		"granted": "Front desk allowed for this group",
		"grantFailed": "Couldn't allow the front desk"
	},
	"form": {
		"required": "Required",
		"textTooLong": "Too long",
		"titleRequired": "Say what the problem is",
		"bodyRequired": "Write a note",
		"buildingRequired": "Pick the building",
		"roomBothGiven": "Pick a room or type its number, not both",
		"nothingToChange": "Nothing to change"
	}
}
